export function backendUrl(){
    const fullUrl = window.location.host
    const parts = fullUrl.split('.')
    const clientShortName = parts[0]
    const app_status = process.env.VUE_APP_STATUS !== undefined ? process.env.VUE_APP_STATUS : 'production'
    const app_backend_port = process.env.VUE_APP_BACKEND_PORT !== undefined ? process.env.VUE_APP_BACKEND_PORT : '8081'
    const app_client_short_name = process.env.VUE_APP_CLIENT_SHORT_NAME

    let url = ''

    if( app_status == 'localhost')
    {
        url = 'http://' + clientShortName + '.localhost:' + app_backend_port + '/api/' + clientShortName
    } else if( app_status == 'staging') {
        url = 'https://v3stagingapi.nnsend.net/api/' + clientShortName
    } else if( app_status == 'production') {
        url = 'https://apibeta.nnsend.net/api/' + clientShortName
    } else if( app_status == 'preprod') {
        // NS-9956 / 10830 Preprod handling
        let clientPreprodName = ''
        clientPreprodName = clientShortName.replace('prod', 'test')
        url = 'https://' + clientShortName + '.v3preprodapi.nnsend.net/api/' + clientPreprodName
    }

    if (app_client_short_name !== undefined && String(app_client_short_name).trim().length > 0) {
        url = 'http://localhost:' + app_backend_port + '/api/' + app_client_short_name
    }

    return url
}